// External Dependencies
import { useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import { toTitleCase } from '@presto-assistant/api_types/utils/toTitleCase';
import { OrganizationEntityTypes, OrgTypes } from '@presto-assistant/api_types';
import { ListAdminOrganizationsResponseItem } from '@presto-assistant/api_types/api/admin/organizations';

// Types
export interface DistrictGroup {
  districtLabel: string;
  organizations: ListAdminOrganizationsResponseItem[];
}

interface DistrictOrganizationListProps {
  adminPortalGroup: DistrictGroup;
}

// Component Definition
const DistrictOrganizationList = ({
  adminPortalGroup,
}: DistrictOrganizationListProps): JSX.Element => {
  const navigate = useNavigate();

  return (
    <List
      dense
      sx={{
        paddingBottom: 2,
        paddingLeft: 2,
      }}
    >
      {adminPortalGroup.organizations.map((org, index, fullList) => {
        const handleNavigateToOrgShowPage = () => {
          navigate(`/organizations/${org.id}`);
        };

        const orgEntityTypeLabel = toTitleCase(
          OrganizationEntityTypes[org.entityTypeId],
        );
        const organizationType = toTitleCase(
          OrgTypes[org.organizationTypeId],
        );

        return (
          <ListItemButton
            divider={index !== fullList.length - 1}
            key={org.id}
            onClick={handleNavigateToOrgShowPage}
          >
            <ListItemText
              primary={org.label}
              secondary={`${orgEntityTypeLabel} ${organizationType}`}
            />
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default DistrictOrganizationList;
